// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59b8a61b","732":"d0d1328f","977":"23448173"}[chunkId] + ".chunk.js";
};